import { Component, Injector, Input, OnInit } from '@angular/core';

import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';
import { PurplWallet } from 'src/app/shared/interfaces/Wallets';

@Component({
  selector: 'app-generic-partner-dashboard-medco',
  templateUrl: './generic-partner-dashboard-medco.component.html',
  styleUrls: ['./generic-partner-dashboard-medco.component.scss'],
})
export class GenericPartnerDashboardMedcoComponent
  extends ListingBaseComponent
  implements OnInit
{
  @Input() wallets: PurplWallet[] = [];

  outgoingFundDetails: any = [];
  filterValue: string = 'last_30_days';

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}
}
